import { MINUTE, type SourceDefinition } from '../types';

export const config = {
  id: 'lifeEvents',
  kind: 'route',
  url: '/api/life/events',
  refetchMiliseconds: 2 * MINUTE,
  staleAfterMiliseconds: 60 * MINUTE,
} satisfies SourceDefinition;
